import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const es = {
  common: {
    streamItem: 'Elemento del flujo',
    description: 'Descripción',
    httpMethod: 'Método HTTP',
    path: 'Ruta',
    copyDefault: 'Copiar valor por defecto',
    copyExample: 'Copiar valor de ejemplo',
  },
  search: {
    label: 'Buscar',
    inputLabel: 'Introduce tu consulta de búsqueda',
    open: 'Abrir búsqueda',
    placeholder: 'Buscar...',
    clear: 'Borrar búsqueda',
    noResults: 'No se encontraron resultados',
    keyboardShortcut: 'Atajo de teclado:',
    command: 'Comando',
    control: 'Control',
    results: 'Resultados de búsqueda de la referencia',
    navigate: 'Navegar',
    select: 'Seleccionar',
    instructions: 'Pulsa flecha arriba o abajo para navegar, Enter para seleccionar y escribe para filtrar resultados',
    entryHeading: 'Encabezado',
    entryOperation: 'Operación',
    entryTag: 'Etiqueta',
    entryTagGroup: 'Grupo de etiquetas',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: 'Introducción',
    closeGroup: 'Cerrar grupo',
    closeMenu: 'Cerrar menú',
    openGroup: 'Abrir grupo',
    openMenu: 'Abrir menú',
    operations: 'Operaciones',
    endpoints: 'Endpoints de {name}',
    showAllEndpoints: 'Mostrar todos los endpoints de {name}',
    sidebarFor: 'Barra lateral de {name}',
    mainContent: 'Documentación de la API de {name}',
    collapsed: 'Contraído',
    webhooks: 'Webhooks',
    channels: 'Canales',
  },
  server: {
    label: 'Servidor',
    select: 'Seleccionar un servidor',
  },
  info: {
    termsOfService: 'Términos del servicio',
  },
  asyncapi: {
    servers: 'Servidores',
    protocols: 'Protocolos',
  },
  clientLibraries: {
    heading: 'Bibliotecas cliente',
    more: 'Más',
    selectAll: 'Seleccionar entre todos los clientes',
  },
  operation: {
    codeSampleUnavailable: 'No hay ninguna muestra de código disponible para este ejemplo.',
    body: 'Cuerpo',
    cookies: 'Cookies',
    headers: 'Encabezados',
    pathParameters: 'Parámetros de ruta',
    queryParameters: 'Parámetros de consulta',
    requestBody: 'Cuerpo de la solicitud',
    responses: 'Respuestas',
    testRequest: 'Probar solicitud',
    webhook: 'Webhook',
    selectedContentType: 'Tipo de contenido seleccionado',
    callbacks: 'Callbacks',
  },
  response: {
    exampleResponses: 'Ejemplos de respuesta',
    noBody: 'Sin cuerpo',
    showSchema: 'Mostrar esquema',
    status: 'Estado',
  },
  schema: {
    noAllowedValues: 'Ningún valor satisface esta restricción enum.',
    example: 'Ejemplo',
    examples: 'Ejemplos',
    default: 'Predeterminado',
    schema: 'Esquema',
    emptyObject: 'Objeto vacío',
    showAdditionalProperties: 'Mostrar propiedades adicionales',
    forName: 'para {name}',
    showSchemaDetails: 'Mostrar detalles del esquema',
    oneOf: 'Uno de',
    anyOf: 'Cualquiera de',
    allOf: 'Todos de',
    not: 'No',
    unknownType: 'tipo desconocido',
    propertyCount: 'Propiedades: {count}',
    headerCount: 'Encabezados: {count}',
    recursiveReference: 'Referencia recursiva a {name}',
    recursive: 'recursivo',
    additionalProperties: 'propiedades adicionales',
    const: 'constante',
    deprecated: 'obsoleto',
    discriminator: 'Discriminador',
    enum: 'enum',
    format: 'Formato',
    greaterThan: 'mayor que',
    keys: 'claves',
    lessThan: 'menor que',
    max: 'máx.',
    min: 'mín.',
    maxLength: 'longitud máx.',
    minLength: 'longitud mín.',
    multipleOf: 'múltiplo de',
    nullable: 'admite null',
    propertyNames: 'nombres de propiedades',
    pattern: 'Patrón',
    copyPattern: 'Copiar patrón',
    readOnly: 'solo lectura',
    required: 'obligatorio',
    hideValues: 'Ocultar valores',
    showAllValues: 'Mostrar todos los valores',
    type: 'Tipo',
    unique: 'único',
    values: 'valores',
    writeOnly: 'solo escritura',
  },
  download: {
    openapi: 'Descargar documento OpenAPI',
    asyncapi: 'Descargar documento AsyncAPI',
  },
  models: {
    label: 'Modelos',
  },
  actions: {
    copyAsMarkdown: 'Copiar como Markdown',
    copied: 'Copiado',
    copyMarkdownFailed: 'No se pudo copiar Markdown',

    copyLink: 'Copiar enlace',
    copyLinkTo: 'Copiar enlace a {name}',
    copyToClipboard: 'Copiar enlace al portapapeles',
    copyEndpointUrl: 'Copiar URL del endpoint',
    showMore: 'Mostrar más',
  },
  agent: {
    askAi: 'Preguntar a IA',
    askAiAgent: 'Preguntar al agente de IA',
    close: 'Cerrar cliente',
  },
  mcp: {
    generate: 'Generar MCP',
    connect: 'Conectar MCP',
  },
  developerTools: {
    title: 'Herramientas de desarrollo',
    configure: 'Configurar',
    share: 'Compartir',
    deploy: 'Desplegar',
    scalarConfiguration: 'Configuración de Scalar',
    theme: 'Tema',
    layout: 'Diseño',
    layoutOptions: 'Opciones de diseño',
    intro:
      'Las herramientas de desarrollo te permiten personalizar la apariencia y el comportamiento de tu documentación. También puedes compartir tu documentación con Scalar Registry.',
    disableToolbarBefore: 'Para desactivar la barra de herramientas, configura',
    disableToolbarAfter: 'en tu configuración.',
    localhostOnly: 'Las herramientas de desarrollo solo aparecerán al ejecutarse en localhost.',
    layoutModern: 'Moderno',
    layoutClassic: 'Clásico',
    showSidebar: 'Mostrar barra lateral',
    defaultOpenFirstTag: 'Abrir la primera etiqueta por defecto',
    defaultOpenAllTags: 'Abrir todas las etiquetas por defecto',
    expandAll: 'Expandir todo {label}',
    expandAllResponses: 'Expandir todas las respuestas',
    hideClientButton: 'Ocultar botón del cliente',
    hideDarkModeToggle: 'Ocultar selector de modo oscuro',
    hideModels: 'Ocultar {label}',
    hideSearch: 'Ocultar búsqueda',
    showOperationId: 'Mostrar ID de operación',
    hideTestRequestButton: 'Ocultar botón de solicitud de prueba',
    scalarDocs: 'Scalar Docs',
    deployDescription:
      'Despliega tu documentación en Scalar, la plataforma moderna de documentación para tu API y mucho más.',
    shareTitle: 'Comparte tu API Reference',
    shareDescription:
      'Sube tu documento OpenAPI para compartir tu API Reference con otras personas. Tan fácil como pulsar un botón.',
    uploadDocument: 'Subir documento',
    temporaryLinkExpiration: 'Tu documento se eliminará automáticamente después de 7 días.',
    deployOnScalar: 'Desplegar en Scalar',
    deployFree: 'Despliega tu documentación gratis.',
    additionalFeaturesMightRequire: 'Las funciones adicionales pueden requerir',
    generate: 'Generar',
    passwordProtection: 'Protección con contraseña',
    customDomains: 'Dominios personalizados',
    freeFormContent: 'Contenido libre',
    cdnInfrastructure: 'Infraestructura CDN',
    pullFromGitHub: 'Importar desde GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Linting de Spectral',
    jsonSchemaHosting: 'Alojamiento de JSON Schema',
    askAi: 'Preguntar a IA',
    mcpServers: 'Servidores MCP',
    unableToExportDocument: 'No se pudo exportar el documento activo',
    unknownError: 'Se produjo un error desconocido',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'Bienvenido a Scalar API References + Swagger Editor, una herramienta gratuita y de código abierto que toma tu archivo Swagger/OAS y genera API References elegantes.',
    showExample: 'Mostrar ejemplo',
    uploadFile: 'Subir archivo',
    integrations: 'INTEGRACIONES',
    theming: 'TEMAS',
    features: 'Funciones',
    customize: 'Personalizar',
    customizeDescription: 'Usa tu tipografía y paletas de colores, o nuestros temas.',
    testing: 'Pruebas',
    testingDescription: 'Un REST API Client profundamente integrado (también gratuito y de código abierto)',
    search: 'Búsqueda',
    searchDescription: 'Búsqueda completamente integrada (con fuse.js)',
    hosting: 'Hosting',
    hostingDescription: 'Hosting gratuito en un subdominio de https://apidocumentation.com',
    openApiSwagger: 'OpenAPI y Swagger',
    openApiSwaggerDescription: 'Compatibilidad con OpenAPI 3.1, OpenAPI 3.0 y Swagger 2.0',
    codeSamples: 'Ejemplos de código',
    codeSamplesDescription: 'Ejemplos de código para mostrar tu API en los lenguajes más populares',
  },
  footer: {
    poweredByScalar: 'Desarrollado por Scalar',
  },
  authentication: {
    title: 'Autenticación',
    accepts: 'Acepta',
    allOf: 'todo lo siguiente:',
    authentication: 'autenticación',
    optional: 'Autenticación opcional',
    oneOf: 'uno de:',
    required: 'Autenticación requerida',
    requires: 'Requiere',
    scopes: 'Ámbitos de OAuth',
  },
} satisfies ApiReferenceTranslations
